import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const scanSerialNumber = createAsyncThunk("scanSerialNumber", async (serialno) => {
	try {
		const token = localStorage.getItem("auth_token");

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};

		return axiosHttp
			.patch(`sn/warehousein?serialNo=${serialno}`, config)
			.then((data) => {
				return data?.data;
			})
			.catch((err) => {
				return err?.response?.data;
			});
	} catch (error) {
		throw error;
	}
});

const ScanSerialNumberSlice = createSlice({
	name: "ScanSerialNumber",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetScanSerialState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(scanSerialNumber.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(scanSerialNumber.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(scanSerialNumber.rejected, (state, action) => {
			state.isLoading = false;
			state.data = null;
			state.error = action.payload;
		});
	},
});

export const { resetScanSerialState } = ScanSerialNumberSlice.actions;
export default ScanSerialNumberSlice.reducer;
